import { create } from 'zustand';
import type { Notification } from '@/types';

interface NotificationState {
  items: Notification[];
  unreadCount: number;
  setItems: (items: Notification[]) => void;
  add: (item: Notification) => void;
  markRead: (id: string) => void;
  markAllRead: () => void;
}

export const useNotificationStore = create<NotificationState>((set) => ({
  items: [],
  unreadCount: 0,
  setItems: (items) => set({ items, unreadCount: items.filter((i) => !i.read).length }),
  add: (item) =>
    set((s) => {
      const items = [item, ...s.items];
      return { items, unreadCount: items.filter((i) => !i.read).length };
    }),
  markRead: (id) =>
    set((s) => {
      const items = s.items.map((i) => (i.id === id ? { ...i, read: true } : i));
      return { items, unreadCount: items.filter((i) => !i.read).length };
    }),
  markAllRead: () =>
    set((s) => ({ items: s.items.map((i) => ({ ...i, read: true })), unreadCount: 0 })),
}));
